import { render } from "./FirstTimerPiechart.vue?vue&type=template&id=7a88972e&scoped=true"
import script from "./FirstTimerPiechart.vue?vue&type=script&lang=js"
export * from "./FirstTimerPiechart.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a88972e"]])

export default __exports__